"use client";
import { ConcieLogoIcon } from "@/public/svg";
import React from "react";
import { Button } from "../ui/button";
import { AuthHeaderProps } from "@/type";

import { usePathname, useRouter } from "next/navigation";
import Link from "next/link";

const AuthHeader: React.FC<AuthHeaderProps> = ({ showLoginButton }) => {
  const router = useRouter();
  const pathname = usePathname();

  // Determine the button text based on the current route
  const buttonText = pathname === "/auth/login" ? "Sign Up" : "Sign In";

  const handleAuthModeToggle = () => {
    if (pathname === "/auth/login") {
      router.push("/auth/signup");
    } else {
      router.push("/auth/login");
    }
  };

  return (
    <div className="flex justify-between items-center p-4 border-b">
      <div className="w-[70px] h-[18px] object-contain">
        <Link href={"https://www.concie.co/"} target="_blank">
          <ConcieLogoIcon />
        </Link>
      </div>
      <div className="flex gap-3">
        {/* /contact-page 404s on the marketing site; use the support mailto. */}
        <Link href={"mailto:support@concie.co"}>
          <Button variant={"outline"}>Contact</Button>
        </Link>
        {showLoginButton && (
          <Button onClick={handleAuthModeToggle} variant={"outline"}>
            {buttonText}
          </Button>
        )}
      </div>
    </div>
  );
};

export default AuthHeader;
